/* eslint-disabled */

export default class PremiumDetailExtend {

    edit = false
    updated = false
    customPremium = 0
    originalPremium = 0
    isCustomized = false
    modifiedBy = ''
    modifiedAt = ''

    constructor(object?: any) {
    }

    postConstruct() {
    }
}
